  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('menu-estatistica')">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
     <div class="text-center">
      <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>

   </div>
    <v-row no-gutters>
      <v-col cols="12" md="1" >
         </v-col>
       <v-col cols="12" md="2" >
          </v-col>
           <v-col cols="12" md="9">
  <input type="radio" name="gender" v-model="row"  value="1"> Barras
  <input type="radio" name="gender" v-model="row" value="2"> Radar
  <input type="radio" name="gender" v-model="row" value="3"> Line
            </v-col>
    </v-row>

<v-row>
        <v-col >

      <div class="container">

       <Bar
      v-if="loaded && row==='1'"
      :chartdata="chartdata"
      :options="options"/>

       <Radar
      v-if="loaded && row==='2'"
      :chartdata="chartdata"
      :options="options"/>

       <LineChart
      v-if="loaded && row==='3'"
      :chartdata="chartdata"
      :options="options"/>

  </div>

      </v-col>

    </v-row>
  </v-container>
  </template>

 </div>
</template>

<script>
import axios from '../../../plugins/axios'
export default {
  name: 'BarChartContainer',
  components: {
    Bar: () => import('../../../components/Bar.vue'),
    LineChart: () => import('../../../components/Chart.vue'),
    Radar: () => import('../../../components/Radar.vue')
  },
  data: () => ({
    row: null,
    loaded: false,
    progresso: false,
    isUpdating: false,
    anoLectivos: [],
    quant: [],
    quantAlunosInstituicaoMasculino: [],
    quantAlunosInstituicaoFemenino: [],
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Masculino',
          borderColor: 'red',
          borderWidth: 12,
          backgroundColor: ['rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 0)'],
          data: []
        },
        {
          label: 'Femenino',
          borderColor: '#1b9e77',
          borderWidth: 12,
          backgroundColor: ['rgb(60, 179, 113)', 'rgb(60, 179, 113)', 'rgb(60, 179, 113)', 'rgb(60, 179, 113)', 'rgb(60, 179, 113)', 'rgb(60, 179, 113)', 'rgb(60, 179, 113)']
        }
      ]
    },

    options: {
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        labels: {
          fontColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)']
        }
      },
      maintainAspectRatio: false
    }
  }),
  created  () {
    this.quantAlunoInstituicaoMasculino()
  },
  async mounted () {
    this.loaded = false
    try {
      //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  methods: {

    async quantAlunoInstituicaoMasculino () {
      this.progresso = true

      try {
        this.quantAlunosInstituicaoMasculino = await axios
          .get('/quantidadeAlunosInstituicaoMasculino')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      } this.quantAlunoInstituicaoFemenino()
    },
    async quantAlunoInstituicaoFemenino () {
      this.progresso = true
      try {
        this.quantAlunosInstituicaoFemenino = await axios
          .get('/quantidadeAlunosInstituicaoFemenino')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      } this.filterMasculinoFemenino()
    },

    filterMasculinoFemenino () {
      let anoLectivosF = []
      let quantF = []
      for (let index = 0; index < this.quantAlunosInstituicaoMasculino.length; index++) {
        this.anoLectivos[index] = (this.quantAlunosInstituicaoMasculino[index].anoLectivo)
        this.quant[index] = (this.quantAlunosInstituicaoMasculino[index].quantidade)
      }
      this.chartdata.labels = this.anoLectivos
      this.chartdata.datasets[0].data = this.quant
      for (let index = 0; index < this.quantAlunosInstituicaoFemenino.length; index++) {
        anoLectivosF.push(this.quantAlunosInstituicaoFemenino[index].anoLectivo)
        quantF.push(this.quantAlunosInstituicaoFemenino[index].quantidade)
      }

      this.chartdata.datasets[1].data = quantF
      this.loaded = false
      this.$nextTick(() => {
        this.row = '1'
        this.loaded = true
      })
    }

  }
}

</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
